import type { JSX } from 'react';

import { Separator, ThemeProvider } from '@change/ds-core-ui/next';

import { Container } from '@change-corgi/design-system-legacy/layout';

import { FormFooter } from '../components/FormFooter';
import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { usePageBody } from '../components/PageBody/hooks/usePageBody';
import { PageBreadcrumb } from '../components/PageBreadcrumb';
import { StrengthTips } from '../components/strengthTips/StrengthTips';

export function Layout(): JSX.Element {
	const {
		data: { selectedTab },
	} = usePageBody();

	return (
		<ThemeProvider>
			<PageBanner />
			<Container>
				<PageBreadcrumb />
			</Container>
			{selectedTab !== 'edit' && <Separator className="sm:-mt-1 md:-mt-0" />}
			{selectedTab === 'edit' && <StrengthTips />}
			<Container>
				<PageBody />
			</Container>
			{selectedTab === 'edit' && <FormFooter />}
		</ThemeProvider>
	);
}
